import {type RouteRecordRaw} from "vue-router";

export const BadRequest: RouteRecordRaw = {
    path: '/400',
    name: '400',
    meta: { allowAnonymous: true },
    component: () => import('./error.vue'),
};

export const Unauthorized: RouteRecordRaw = {
    path: '/401',
    name: '401',
    meta: { allowAnonymous: true },
    component: () => import('./forbidden.vue'),
};

export const Forbidden: RouteRecordRaw = {
    path: '/403',
    name: '403',
    meta: { allowAnonymous: true },
    component: () => import('./forbidden.vue'),
};

export const NotFound: RouteRecordRaw = {
    path: '/404',
    name: '404',
    meta: { allowAnonymous: true },
    component: () => import('./not-found.vue'),
};

export const InternalServerError: RouteRecordRaw = {
    path: '/500',
    name: '500',
    meta: { allowAnonymous: true },
    component: () => import('./error.vue'),
};

export const Error: RouteRecordRaw = {
    path: '/error',
    name: 'error',
    meta: { allowAnonymous: true },
    component: () => import('./error.vue'),
};

export default [
    BadRequest,
    Unauthorized,
    Forbidden,
    NotFound,
    InternalServerError,
    Error,
]